import React from 'react';
import { Link } from 'react-router-dom';

export const HeroSection = () => {
  return (
    <section className="hero-section">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="hero-bg-video"
        poster="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1920&q=80"
      >
        <source
          src="https://assets.mixkit.co/videos/preview/mixkit-people-working-in-a-modern-office-4949-large.mp4"
          type="video/mp4"
        />
        Su navegador no soporta videos HTML5.
      </video>
      <div className="hero-overlay"></div>

      <div className="hero-content container">
        <h1 className="hero-title">
          Contadores Públicos en Corrientes Capital
        </h1>
        <p className="hero-subtitle">
          R&M Estudio Contable: Transformamos la complejidad impositiva, laboral y societaria en la tranquilidad de su empresa en Corrientes.
        </p>
        <Link to="/contacto" className="btn-primary">
          Agendar Consulta Estratégica
        </Link>
      </div>
    </section>
  );
};
